import {createStyles} from '@material-ui/core';

export const style = createStyles({
  modal: {
    paddingBottom: '8px',
    overflow: 'visible',
  },
});
